<template>
  <div class="wrap">
    <!-- 微信认证组件 -->
    <wxAuth v-if="share" :share="share"></wxAuth>
    <headers :params="hraderP" />
    <van-form class="form" ref="formData" @submit="subMit">
      <van-field
        v-model="form.bandName"
        required
        clearable
        label="品牌名称"
        placeholder="请输入品牌名称"
        maxlength="30"
        :show-error-message="false"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="form.companyName"
        clearable
        label="公司名称"
        placeholder="请输入公司名称"
        maxlength="30"
      />
      <van-field
        v-model="form.natureBusiness"
        clearable
        label="经营范围"
        placeholder="请输入经营范围"
        maxlength="30"
      />
      <van-field
        v-model="form.contactName"
        required
        clearable
        label="联系人"
        placeholder="请输入联系人"
        :show-error-message="false"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="form.mobileTel"
        required
        clearable
        type="number"
        label="联系方式"
        maxlength="11"
        placeholder="请输入联系方式"
        :show-error-message="false"
        :rules="[{ validator, message: '' }]"
      />
      <van-field
        v-model="form.projectName"
        clearable
        label="企业简介"
        placeholder="请输入企业简介"
        readonly
      />
      <van-field
        class="textarea"
        v-model="form.companyBrief"
        rows="3"
        type="textarea"
        maxlength="500"
        placeholder="请输入企业简介"
        show-word-limit
      />
    </van-form>
    <div class="flex-row">
      <div @click="reset">取消</div>
      <div @click="printFormValue">提交</div>
    </div>
  </div>
</template>

<script>
import headers from '@/components/headers'
import { addBrandRecommendation } from '@/api/brand/brands'
import { toLogin, isMobile } from '@/utils/common'
import wxAuth from '@/components/wxAuth'

export default {
  data () {
    return {
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '品牌推荐表单',
        lefticon: true
      },
      form: {},
      userInfo: {}
    }
  },
  components: {
    headers,
    wxAuth
  },
  mounted () {
    if (!isMobile()) {
      console.log(`${process.env.PC_SOLUTION_URL || '//solution.homedo.com'}/design/partner.html`)
      window.location.href = `${process.env.PC_SOLUTION_URL || '//solution.homedo.com'}/design/partner.html`
    }
    this.getUserInfo().then((res) => {
      this.userInfo = res
    })
  },
  methods: {
    async getUserInfo () {
      return new Promise((resolve, reject) => {
        $HMD$.GetLogin(function (data) {
          resolve(data)
        })
      })
    },
    validator (val) {
      return /1\d{10}/.test(val)
    },
    reset () {
      this.$router.push('/activity/dsg/rAndI.html')
    },
    subMit () {
      this.form.ownerId = this.userInfo.AccountId
      this.form.ownerName = this.userInfo.AccountName
      this.form.createBy = this.userInfo.AccountId
      this.form.createName = this.userInfo.AccountName
      if (!this.form.createBy) {
        toLogin()
      }
      addBrandRecommendation(this.form).then((res) => {
        let { status, data } = res
        if (status == 200) {
          let { code } = data
          if (code == 200) {
            this.$toast.success('提交成功')
            setTimeout(() => {
              this.$router.push('/activity/dsg/rAndI.html')
            }, 300)
          } else {
            this.$toast.fail('请填写必填数据 再次提交')
          }
        }
      })
    },
    printFormValue () {
      this.$refs.formData.submit()
    }
  }
}
</script>

<style scoped>
.wrap {
  background: #fff;
  height: 100%;
}
.form {
  padding: 0 10px;
}
.textarea {
  width: 319px;
  height: 118px;
  background: #f8f9fb;
  margin: 12px auto;
  margin-top: -2px;
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background: #fff;
  height: 100px;
}
.flex-row div {
  width: 142px;
  height: 44px;
}
.flex-row div:nth-child(1) {
  background: rgba(202, 202, 202, 1);
  color: #fff;
  font-size: 16px;
  line-height: 44px;
  text-align: center;
  border-radius: 22px;
}
.flex-row div:nth-child(2) {
  background: rgba(46, 123, 255, 1);
  color: #fff;
  font-size: 16px;
  line-height: 44px;
  text-align: center;
  border-radius: 22px;
}
</style>



// WEBPACK FOOTER //
// src/view/activities/designer/recommendation.vue